module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.currentProject) ? _c('div', {
    staticClass: "create-requirements-button"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-requirement-modal-RequirementsView",
      modifiers: {
        "create-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("New requirement")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-folder-modal-RequirementsView",
      modifiers: {
        "create-folder-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("New folder")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.import-issues-modal",
      modifiers: {
        "import-issues-modal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("Import requirements")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.export-requirements-modal",
      modifiers: {
        "export-requirements-modal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v("Export requirements")])], 1) : _vm._e(), _vm._v(" "), _c('create-requirement-modal', {
    attrs: {
      "modalId": "create-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('create-folder-modal', {
    attrs: {
      "modalId": "create-folder-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('import-issues-modal', {
    attrs: {
      "currentProject": _vm.currentProject
    }
  }), _vm._v(" "), _c('export-requirements-modal'), _vm._v(" "), _c('move-requirement-modal', {
    attrs: {
      "requirements": _vm.selectedRequirements,
      "modalId": "move-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), _c('delete-requirement-modal', {
    attrs: {
      "requirements": _vm.selectedRequirements,
      "modalId": "delete-requirement-modal-RequirementsView"
    }
  }), _vm._v(" "), (_vm.currentProject) ? _c('div', [(this.items.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-3 items-list-outer"
  }, [_c('div', {
    style: (_vm.selectedRequirements.length > 0 ? '' : 'visibility: hidden;')
  }, [_c('span', [_vm._v("Selected: ")]), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.move-requirement-modal-RequirementsView",
      modifiers: {
        "move-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("\n          Move\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.delete-requirement-modal-RequirementsView",
      modifiers: {
        "delete-requirement-modal-RequirementsView": true
      }
    }],
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("\n            Delete\n          ")])], 1), _vm._v(" "), _c('items-list', {
    attrs: {
      "items": _vm.items
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.currentItem && _vm.currentItem.type.endsWith('requirement')) ? _c('requirements-detail', {
    attrs: {
      "id": Number.parseInt(_vm.currentItem.requirement_id)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentItem && _vm.currentItem.type === 'folder') ? _c('folder-detail', {
    attrs: {
      "folderId": Number.parseInt(_vm.currentItem.folder_id)
    }
  }) : _vm._e()], 1)]) : (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": "",
      "scale": "5"
    }
  })], 1)]) : _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v("Create your first requirement by clicking the \"New requirement\" button above")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608f7c89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequirementsView.vue
// module id = 1016
// module chunks = 1